//* 概况图
//- 2. 绘制逻辑
//* 1. Exon尺寸 40 ~ 320, 默认比例 2:1
//* 2. Intron尺寸 40, 固定40尺寸, 动态比例

//* 详细图
//- 2. 绘制逻辑
//* 2.1 Exon尺寸 40 ~ 320, 默认比例 2:1
//* 2.2 Intron尺寸 25 ~ 80, 最小25最大80尺寸, 动态比例
//* 2.2.1 小于100bp时长度为25 ~ 50, 默认比例 2:1
//* 2.2.2 大于100bp时长度固定80, 取前后100bp以2:1比例绘制, 其余按动态比例的bp:30绘制

//* 新增内容
//- 1. 基于基因长度补充Mrna前后的Intron

/* eslint-disable no-dupe-class-members */
export class disposeData {
    data: any[] = [];
    dictionaries: any[] = [];

    cds;
    size;
    view;
    exons;
    length;

    constructor(data: any, view = {}) {
        this.view = view; //? 视图参数
        this.cds = data.cds || []; //? cds数据
        this.size = 0; //? 绘制图像实际尺寸
        this.data = []; //? 实例化class后的预处理数据
        this.exons = data.exons || []; //? exon数据
        this.length = data.length || 0; //? 基因长度
        this.dictionaries = []; //? 绘图字典, 用于坐标计算与绘图

        //- 1. 数据分类生成Exon, Intron字典集
        this.#disposeClassify();
    }

    //* 数据分类生成Exon, Intron字典集
    #disposeClassify() {
        //- 1. 初始化配置数据
        const config = { cdsPos: 1, eggPos: 1, eggDiff: 0 };

        //- 2. 遍历Exons生成Exon, Intron字典集
        this.data = [];
        this.exons.forEach((exon: number[], index: number) => {
            const size = exon[1] - exon[0] + 1;
            const front = this.exons[index - 1] || [];
            const frontEnd = front?.[1] || 0;
            //- 2.1 判断Exon之前是否存在一段Intron
            if (exon[0] - frontEnd > 1) {
                this.data.push({ start: frontEnd + 1, end: exon[0] - 1, size: exon[0] - frontEnd - 2, type: "intron" });
            }

            //- 2.2 添加Exon数据, 并处理cds数据生成强关联的蛋白数据与cds数据
            this.data.push(this.#disposeExon({ start: exon[0], end: exon[1], size: size, type: "exon", name: `E${index + 1}` }, config));
        });

        //- 2.3 判断尾部是否存在一段Intron
        const queen = this.data.slice(-1)[0] || {};
        if (queen && queen.end < this.length) {
            this.data.push({ start: queen.end + 1, end: this.length, size: this.length - queen.end, type: "intron" });
        }
    }

    //* 将cds和exon数据进行强关联, 并计算出蛋白的坐标
    #disposeExon(data: any, config: any) {
        //- 1. 完全相信后端CDS坐标没问题, 有问题找后端
        for (let i in this.cds) {
            const value = this.cds[i];
            if (data.start <= value[0]) {
                //- 1.1 Exon起始坐标在CDS左侧
                if (data.end >= value[0] && value[1] >= data.end) {
                    //- 1.1.1 Exon终点坐标在CDS内部
                    data.cds = { end: data.end, start: value[0], size: data.end - value[0] + 1 };
                } else if (data.end >= value[1]) {
                    //- 1.1.2 Exon终点坐标在CDS右侧
                    data.cds = { end: value[1], start: value[0], size: value[1] - value[0] + 1 };
                }
            } else if (data.start <= value[1]) {
                //- 1.2 Exon起始坐标在CDS内部
                if (data.end >= value[0] && value[1] >= data.end) {
                    //- 1.2.1 Exon终点坐标在CDS内部
                    data.cds = { end: data.end, start: data.start, size: data.end - data.start + 1 };
                } else if (data.end >= value[1]) {
                    //- 1.2.2 Exon终点坐标在CDS右侧
                    data.cds = { start: data.start, end: value[1], size: value[1] - data.start + 1 };
                }
            }

            //- 2. 判断是否存在CDS区域, 存在则计算CDS相对坐标, 蛋白相对坐标并返回数据
            if (data.cds) {
                const diff = data.cds.size - config.eggDiff;
                data.cds.rEnd = config.cdsPos + data.cds.size - 1;
                data.cds.rStart = config.cdsPos;
                data.eggWhite = { start: config.eggPos, end: config.eggPos + Math.ceil(diff / 3) - 1 };
                config.cdsPos = config.cdsPos + data.cds.size;
                config.eggPos = config.eggPos + Math.ceil(diff / 3);
                if (diff % 3 != 0) {
                    config.eggDiff = 3 - (diff % 3);
                }

                return data;
            }
        }

        return data;
    }

    //* 概括图绘图数据计算函数
    disposeOverviewData() {
        //- 1. 初始化数据
        this.size = 0;
        this.dictionaries = [];
        const config = { offset: 0 };

        //- 2. 遍历预处理数据生成绘图数据
        this.data.forEach((value) => {
            switch (value.type) {
                case "intron": {
                    this.size += 64;
                    this.dictionaries.push(Object.assign(value, { width: 64, ratio: 64 / value.size, offset: config.offset }));
                    config.offset += 64;
                    break;
                }

                case "exon": {
                    const width = value.size * 0.5;
                    const result = Object.assign(value, { width: width, ratio: 0.5, offset: config.offset });
                    if (width < 40) {
                        result.width = 40;
                        result.ratio = 40 / value.size;
                    } else if (width > 320) {
                        result.width = 320;
                        result.ratio = 320 / value.size;
                    }

                    this.dictionaries.push(result);
                    this.size += result.width;
                    config.offset += result.width;
                    break;
                }
            }
        });
    }

    //* 详细图绘图数据计算函数
    disposeDetailsData() {
        //- 1. 初始化数据
        this.size = 0;
        this.dictionaries = [];
        const config = { offset: 0 };

        //- 2. 遍历预处理数据生成绘图数据
        this.data.forEach((value) => {
            switch (value.type) {
                case "intron": {
                    const result = Object.assign(value, { ratio: 0.5, offset: config.offset });
                    if (value.size <= 100) {
                        result.width = value.size * 0.5;
                        if (result.width < 25) {
                            result.width = 25;
                            result.ratio = 25 / value.size;
                        }
                    } else {
                        result.omit = 30 / (value.size - 100);
                        result.width = 80;
                    }

                    this.dictionaries.push(result);
                    this.size += result.width;
                    config.offset += result.width;
                    break;
                }

                case "exon": {
                    const width = value.size * 0.5;
                    const result = Object.assign(value, { width: width, ratio: 0.5, offset: config.offset });
                    if (width < 40) {
                        result.width = 40;
                        result.ratio = 40 / value.size;
                    } else if (width > 320) {
                        result.width = 320;
                        result.ratio = 320 / value.size;
                    }

                    this.dictionaries.push(result);
                    this.size += result.width;
                    config.offset += result.width;
                    break;
                }
            }
        });
    }

    //* 坐标转换函数
    disposePos(site: number, option: any) {
        //- 数据初始化
        option = option || { align: "left" };
        //- return数据初始化
        const result = { offset: 0, data: null, site: 0 };
        //- 遍历dictionaries获取坐标
        for (let i = 0, l = this.dictionaries.length; i < l; i++) {
            const value = this.dictionaries[i];
            if (site <= value.end && site >= value.start) {
                result.data = value;
                result.site = site;

                //- Intron省略计算处理
                if (value.omit) {
                    //- 获取当前偏移
                    result.offset = value.offset;

                    //- 左侧横线区域计算
                    if (site - value.start < 50) {
                        result.offset += (site - value.start) * value.ratio;
                    } else {
                        result.offset += 25;
                    }

                    //- 中间省略与右侧横线区域计算
                    if (site - value.start > 50) {
                        if (value.end - site >= 50) {
                            result.offset += (site - value.start) * value.omit;
                        } else {
                            result.offset += 30 + (site - value.end + 51) * value.ratio;
                        }
                    }
                } else {
                    result.offset = value.offset + (site - value.start) * value.ratio;
                }

                //- 边界检测
                if (result.site < value.start) result.site = value.start;
                if (result.site > value.end) result.site = value.end;

                switch (option.align) {
                    case "right": {
                        result.offset += value.ratio;
                        break;
                    }

                    case "center": {
                        result.offset += value.ratio / 2;
                        break;
                    }
                }

                return result;
            }
        }

        return result;
    }
}
